<template>
  <div class="row">
    <div class="col-md-12">
      <selects
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeOptionTodos="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      ></selects>
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="info-table py-4">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="tria"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :data_secretaria_de_saude="data_secretaria_de_saude"
              :loading="loading"
              texto_esus_pec="Dados registrados e processados até "
              :data_esus_pec="data_secretaria_de_saude"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { chartOptions, dataFields, groupFilterItems } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import TabelaResultado from './TabelaResultado.vue'

export default {
  name: 'TriaPorEquipeAcs',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    Selects,
    TabelaResultado,
  },
  mixins: [utils],
  data() {
    return {
      loadingGrafico: false,
      size: '40px',
      color: '#0D98BB',
      micro_areas: [],
      micro_area: '',
      select_microarea: '',
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      nomeProfissional: '',
      cadastros: [],
      cadastrosOriginais: [],
      data_ministerio_da_saude: null,
      data_secretaria_de_saude: '',
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      filterSearchTable: false,
      equipeEvent: '',
      chartData: [],
      chartOptions: {
        ...chartOptions,
      },
      setRed: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      this.cadastros = this.cadastrosOriginais
      let response = Filter.filtro(
        this.cadastros,
        this.equipe,
        this.profissional,
        this.micro_area,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },

    ...mapState(['user']),

    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },

  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        // mostra os vermelhos
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        // mostra os verdes
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      if (event !== null) {
        this.equipeEvent = event
        this.profissionais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.micro_area = ''
        this.select_microarea = ''
        this.cadastros = this.cadastrosOriginais
        this.equipe = event
      } else {
        this.equipeEvent = ''
        this.profissionais = []
        this.profissionais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.micro_area = ''
        this.select_microarea = ''
        this.equipe = ''
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.micro_area = ''
      this.select_microarea = ''
      if (event !== null) {
        this.profissional = event.nu_cpf
        this.nomeProfissional = event.no_profissional
      } else {
        this.profissional = ''
        this.nomeProfissional = ''
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.profissional = ''
      this.nomeProfissional = ''
      this.select_profissional = ''
      if (event !== null) {
        this.situacao = ''
        this.micro_area = event?.micro_area
      } else {
        this.micro_area = ''
        this.select_microarea = ''
      }
    },

    async buscarDadosIniciais() {
      try {
        let response = await this.$api.get(`/app/tria/${this.cod_ibge}`)
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    async buscarUltimaAtualizacao() {
      let response = await Functions.getUltimaAtualizacao(this.cod_ibge)
      if (response) {
        this.data_secretaria_de_saude = this.formatDate(
          response.data_sincronizacao
        )
        this.data_ministerio_da_saude = response.quadrimestre
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarUltimaAtualizacao()
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
